import React from "react";
const IconDoubleChevronDown = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M4.5 10.25L10 15.75L15.5 10.25" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
    <path d="M4.5 4.25L10 9.75L15.5 4.25" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
  </svg>
);
export default IconDoubleChevronDown;
